<div class="container-fluid" *ngIf="data; else loadingTpl">
  <div class="row mb-4">
    <div class="col-12">
      <div class="ai-box p-4 text-white rounded shadow-sm">
        <div class="d-flex justify-content-between align-items-center"><h4 class="mb-0">🧠 Market Intelligence</h4><span
          class="badge badge-light p-2 text-dark">{{ data.ai.sentiment }}</span></div>
        <p class="lead mt-2 mb-0">{{ data.ai.strategy }}</p></div>
    </div>
  </div>
  <div class="row mb-4">
    <div class="col-md-3">
      <div class="card h-100 shadow-sm border-0">
        <div class="card-body text-center">
          <div class="text-uppercase text-muted font-weight-bold small mb-2">Fear & Greed</div>
          <div class="h2 font-weight-bold">{{ data.vitals.fgScore }}</div>
          <div class="progress mt-2" style="height: 8px;">
            <div class="progress-bar" role="progressbar"
                 [style.width.%]="data.vitals.fgScore"
                 [style.background]="'linear-gradient(90deg, #ff5252 0%, #ffd740 50%, #00e676 100%)'"></div>
          </div>
          <div class="small mt-2 text-muted">{{ data.vitals.fgText }}</div>
        </div>
      </div>
    </div>
    <div class="col-md-3">
      <div class="card h-100 shadow-sm border-0">
        <div class="card-body text-center">
          <div class="text-uppercase text-muted font-weight-bold small mb-2">Momentum</div>
          <div class="h2 font-weight-bold"
               [class.text-success]="data.vitals.momentum > 0"
               [class.text-danger]="data.vitals.momentum < 0"> {{ data.vitals.momentum > 0 ? '+' : '' }}{{ data.vitals.momentum }}
            %
          </div>
          <div class="small mt-2 text-muted">Avg Change (Top 50)</div>
        </div>
      </div>
    </div>
    <div class="col-md-3">
      <div class="card h-100 shadow-sm border-0">
        <div class="card-body text-center">
          <div class="text-uppercase text-muted font-weight-bold small mb-2">Liquidity Pulse</div>
          <div class="h2 font-weight-bold">{{ data.vitals.liquidityPct }}%</div>
          <div class="progress mt-2" style="height: 8px;">
            <div class="progress-bar bg-info" role="progressbar"
                 [style.width.%]="data.vitals.liquidityPct > 100 ? 100 : data.vitals.liquidityPct"></div>
          </div>
          <div class="small mt-2 text-muted">of 10-Day Avg Volume</div>
        </div>
      </div>
    </div>
    <div class="col-md-3">
      <div class="card h-100 shadow-sm border-0">
        <div class="card-body text-center">
          <div class="text-uppercase text-muted font-weight-bold small mb-2">Breadth (A/D)</div>
          <div class="h2 font-weight-bold"><span class="text-success">{{ data.summary.advancers }}</span> /
            <span class="text-danger">{{ data.summary.decliners }}</span></div>
          <div class="progress mt-2" style="height: 8px;">
            <div class="progress-bar bg-success" role="progressbar"
                 [style.width.%]="(data.summary.advancers / data.summary.total) * 100"></div>
            <div class="progress-bar bg-danger" role="progressbar"
                 [style.width.%]="(data.summary.decliners / data.summary.total) * 100"></div>
          </div>
          <div class="small mt-2 text-muted">Advancers vs Decliners</div>
        </div>
      </div>
    </div>
  </div>
  <div class="card shadow-sm border-0 no-hover-transition">
    <div class="card-header bg-white d-flex justify-content-between align-items-center py-3">

      <!-- <h5
      class="mb-0 font-weight-bold text-dark">Live Market Scanner</h5> -->
      <div class="filter-section">
        <div class="d-flex align-items-center mr-3">
          <label class="mr-2 mb-0 font-weight-bold text-muted small">Search: </label>
          <input type="text"
                 class="form-control form-control-sm"
                 style="width: 200px; margin-left: 10px;"
                 placeholder="Search by stock code..."
                 [(ngModel)]="filterStockCode"
                 (input)="filterStocks()">
        </div>
        <div class="d-flex align-items-center">
          <label class="mr-2 mb-0 font-weight-bold text-muted small">Filter by Signal: </label>
          <select class="form-control filter-dropdown form-control-sm"
                  style="width: 150px;"
                  [(ngModel)]="filterSignal"
                  (change)="filterStocks()">
            <option value="">Show All</option>
            <option value="BREAKOUT">Breakout</option>
            <option value="BUY DIP">Buy Dip</option>
            <option value="VOL SPIKE">Vol Spike</option>
            <option value="WEAK">Weak</option>
          </select>
        </div>
      </div>
    </div>
    <div class="card-body p-0">
      <div class="table-responsive">
        <table class="table table-hover mb-0">
          <thead class="thead-light">
          <tr>
            <th class="border-top-0" (click)="sortByName('code')" style="cursor: pointer;">
              <div class="d-flex align-items-center justify-content-between">
                <span>Stock</span>
                <i class="fa" [ngClass]="getSortIcon('code')" aria-hidden="true"></i>
              </div>
            </th>
            <th class="border-top-0" (click)="sortByName('price')" style="cursor: pointer;">
              <div class="d-flex align-items-center justify-content-between">
                <span>Price</span>
                <i class="fa" [ngClass]="getSortIcon('price')" aria-hidden="true"></i>
              </div>
            </th>
            <th class="border-top-0 text-center" (click)="sortByName('signal')" style="cursor: pointer;">
              <div class="d-flex align-items-center justify-content-center">
                <span class="mr-2">Signal</span>
                <i class="fa" [ngClass]="getSortIcon('signal')" aria-hidden="true"></i>
              </div>
            </th>
            <th class="border-top-0" style="width: 35%; cursor: pointer;" (click)="sortByName('reasoning')">
              <div class="d-flex align-items-center justify-content-between">
                <span>Detailed Analysis</span>
                <i class="fa" [ngClass]="getSortIcon('reasoning')" aria-hidden="true"></i>
              </div>
            </th>
            <th class="border-top-0 text-center" (click)="sortByName('volRatio')" style="cursor: pointer;">
              <div class="d-flex align-items-center justify-content-center">
                <span class="mr-2">Vol Ratio</span>
                <i class="fa" [ngClass]="getSortIcon('volRatio')" aria-hidden="true"></i>
              </div>
            </th>
            <th class="border-top-0" style="width: 15%;">10d Range</th>
            <th class="border-top-0" style="width: 15%;">10w Range</th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let row of paginatedStocks">
            <td class="align-middle font-weight-bold">{{ row.code }}</td>
            <td class="text-right" style="vertical-align: middle;">{{ row?.price | number:'1.2-2' }}</td>
            <td >
              <span class="badge-div"
                    [ngClass]="{
                            'badge-success': row.color === 'success',
                            'badge-danger': row.color === 'danger',
                            'badge-info': row.color === 'info',
                            'badge-warning': row.color === 'warning',
                            'badge-secondary': row.color === 'secondary'
                          }">
                {{ row.signal }}
              </span>
            </td>
            <td class="align-middle small text-secondary">
              <span *ngIf="row?.ai"
                    class="badge badge-primary mr-1"
                    style="background: linear-gradient(45deg, #667eea, #764ba2);"> AI
              </span>
              {{ row.reasoning }}
            </td>
            <td class="align-middle text-center" style="vertical-align: middle;"><strong>{{ row.volRatio }}x</strong></td>
            <td class="align-middle">
              <div class="d-flex align-items-center" style="font-size: 0.75rem;"><span
                class="text-muted mr-1">{{ row.low10d | number:'1.0-0' }}</span>
                <div class="progress flex-grow-1" style="height: 6px; background-color: #e9ecef;">
                  <div class="progress-bar bg-info" role="progressbar"
                       [style.width.%]="calculateProgress(row.price, row.low10d, row.high10d)"></div>
                </div>
                <span class="text-muted ml-1">{{ row.high10d | number:'1.0-0' }}</span></div>
            </td>
            <td class="align-middle">
              <div class="d-flex align-items-center" style="font-size: 0.75rem;"><span
                class="text-muted mr-1">{{ row.low10w | number:'1.0-0' }}</span>
                <div class="progress flex-grow-1" style="height: 6px; background-color: #e9ecef;">
                  <div class="progress-bar bg-primary" role="progressbar"
                       [style.width.%]="calculateProgress(row.price, row.low10w, row.high10w)"></div>
                </div>
                <span class="text-muted ml-1">{{ row.high10w | number:'1.0-0' }}</span></div>
            </td>
          </tr>
          @if(filteredStocks?.length === 0) {
            <tr>
              <td class="text-center"  colspan="7">
                  No data available.
              </td>
            </tr>
          }
          </tbody>
        </table>
      </div>
      <mat-paginator
        [length]="filteredStocks.length"
        [pageSize]="pageSize"
        [pageIndex]="pageIndex"
        [pageSizeOptions]="pageSizeOptions"
        [showFirstLastButtons]="true"
        (page)="onPageChange($event)">
      </mat-paginator>
    </div>
  </div>
</div>
<ng-template #loadingTpl>
  <div class="d-flex justify-content-center align-items-center" style="height: 100vh;">
    <div class="spinner-border text-primary" role="status">
<!--      <span class="sr-only">Loading market data...</span>-->
    </div>
    <div class="ml-3 text-muted">Loading DSC Dashboard...</div>
  </div>
</ng-template>
